import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  ExamCenterService,
  ExamService,
} from '../../../services';
import {
  Exam,
  ExamCenter,
  ExamEvent,
} from '../../../types';

@Component({
  selector: 'app-exam-event-details-dialog',
  templateUrl: './exam-event-details-dialog.component.html',
  styleUrls: ['./exam-event-details-dialog.component.scss'],
})
export class ExamEventDetailsDialogComponent
  implements OnInit
{
  @Input() examEvent!: ExamEvent;

  exam!: Exam;
  examCenter!: ExamCenter;

  constructor(
    public bsModalRef: BsModalRef<ExamEventDetailsDialogComponent>,
    public translateService: TranslateService,
    public examService: ExamService,
    public examCenterService: ExamCenterService
  ) {}

  async ngOnInit(): Promise<void> {
    this.exam = await this.examService.loadExamById(
      this.examEvent.testId
    );

    this.examCenter = await this.examCenterService.loadById(
      this.examEvent.testcentersId
    );
  }

  get currentLanguage(): string {
    return this.translateService.currentLang;
  }
}
